// extracted by mini-css-extract-plugin
export default {"menu_item":"MenuLink_menu_item__EFGpB","active":"MenuLink_active__W6irC"};